import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "settings p-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-xl mb-4 pl-2" }, "Settings", -1)
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "col-span-10 md:col-span-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-left" }, "User Settings", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-left" }, "Update Password", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-left" }, "Company Info", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "text-left" }, "Apps Connection", -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "text-left" }, "User Managment", -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "text-left" }, "Reports", -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "text-left" }, "Payment Info", -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "text-left" }, " Subscription ", -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "col-span-10 md:col-span-8" }
const _hoisted_22 = { class: "onboarding-card" }
const _hoisted_23 = { class: "w-full" }
const _hoisted_24 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_25 = { class: "onboarding-card" }
const _hoisted_26 = { class: "w-full" }
const _hoisted_27 = { class: "onboarding-card" }
const _hoisted_28 = { class: "w-full" }
const _hoisted_29 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_30 = { class: "onboarding-card" }
const _hoisted_31 = { class: "w-full" }
const _hoisted_32 = { class: "onboarding-card" }
const _hoisted_33 = { class: "w-full" }
const _hoisted_34 = { class: "block flex flex-row mb-4" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-left font-medium text-xl" }, "All Users")
], -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1)
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { class: "onboarding-card" }
const _hoisted_39 = { class: "onboarding-card" }
const _hoisted_40 = { class: "w-full" }
const _hoisted_41 = { class: "onboarding-card" }
const _hoisted_42 = { class: "w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tab = _resolveComponent("Tab")!
  const _component_TabList = _resolveComponent("TabList")!
  const _component_UserInfoForm = _resolveComponent("UserInfoForm")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_ResetPasswordForm = _resolveComponent("ResetPasswordForm")!
  const _component_CompanyInfoForm = _resolveComponent("CompanyInfoForm")!
  const _component_AppConnection = _resolveComponent("AppConnection")!
  const _component_CompanyUserInviteModal = _resolveComponent("CompanyUserInviteModal")!
  const _component_CompanyUserList = _resolveComponent("CompanyUserList")!
  const _component_ReportForm = _resolveComponent("ReportForm")!
  const _component_UserPaymentEntry = _resolveComponent("UserPaymentEntry")!
  const _component_SubscriptionSelection = _resolveComponent("SubscriptionSelection")!
  const _component_TabPanels = _resolveComponent("TabPanels")!
  const _component_TabGroup = _resolveComponent("TabGroup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (!_ctx.loadingInitial)
      ? (_openBlock(), _createBlock(_component_TabGroup, {
          key: 0,
          defaultIndex: _ctx.selectedTab,
          vertical: "",
          class: "grid grid-cols-10 gap-6"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_TabList, { class: "flex flex-col space-y-2 rounded-md" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Tab, null, {
                      default: _withCtx(({ selected }) => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["w-full rounded-lg p-2", [selected ? 'bg-teal text-white' : '']])
                        }, _hoisted_6, 2)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Tab, null, {
                      default: _withCtx(({ selected }) => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["w-full rounded-lg p-2", [selected ? 'bg-teal text-white' : '']])
                        }, _hoisted_8, 2)
                      ]),
                      _: 1
                    }),
                    (_ctx.isAdmin)
                      ? (_openBlock(), _createBlock(_component_Tab, { key: 0 }, {
                          default: _withCtx(({ selected }) => [
                            _createElementVNode("div", {
                              class: _normalizeClass(["w-full rounded-lg p-2", [selected ? 'bg-teal text-white' : '']])
                            }, _hoisted_10, 2)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.isAdmin)
                      ? (_openBlock(), _createBlock(_component_Tab, { key: 1 }, {
                          default: _withCtx(({ selected }) => [
                            _createElementVNode("div", {
                              class: _normalizeClass(["w-full rounded-lg p-2", [selected ? 'bg-teal text-white' : '']])
                            }, _hoisted_12, 2)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_Tab, null, {
                      default: _withCtx(({ selected }) => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["w-full rounded-lg p-2", [selected ? 'bg-teal text-white' : '']])
                        }, _hoisted_14, 2)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Tab, null, {
                      default: _withCtx(({ selected }) => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["w-full rounded-lg p-2", [selected ? 'bg-teal text-white' : '']])
                        }, _hoisted_16, 2)
                      ]),
                      _: 1
                    }),
                    (_ctx.isAdmin && !_ctx.msAppLoaded || _ctx.isAdmin && _ctx.msAppLoaded && !_ctx.isMobile)
                      ? (_openBlock(), _createBlock(_component_Tab, { key: 2 }, {
                          default: _withCtx(({ selected }) => [
                            _createElementVNode("div", {
                              class: _normalizeClass(["w-full rounded-lg p-2", [selected ? 'bg-teal text-white' : '']])
                            }, _hoisted_18, 2)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.isAdmin && !_ctx.msAppLoaded || _ctx.isAdmin && _ctx.msAppLoaded && !_ctx.isMobile)
                      ? (_openBlock(), _createBlock(_component_Tab, { key: 3 }, {
                          default: _withCtx(({ selected }) => [
                            _createElementVNode("div", {
                              class: _normalizeClass(["w-full rounded-lg p-2", [selected ? 'bg-teal text-white' : '']])
                            }, _hoisted_20, 2)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_TabPanels, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_TabPanel, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createVNode(_component_UserInfoForm, {
                              onUser: _ctx.updateUserSubmitted,
                              loading: _ctx.loadingUserUpdate,
                              userData: _ctx.userData,
                              isUpdate: true
                            }, null, 8, ["onUser", "loading", "userData"]),
                            (_ctx.userError)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.userError), 1))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_TabPanel, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _createVNode(_component_ResetPasswordForm, { isSettings: true })
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    (_ctx.isAdmin)
                      ? (_openBlock(), _createBlock(_component_TabPanel, { key: 0 }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("div", _hoisted_28, [
                                _createVNode(_component_CompanyInfoForm, {
                                  loading: _ctx.loadingCompanyUpdate,
                                  companyData: _ctx.companyData,
                                  onCompany: _ctx.updateCompanySubmitted
                                }, null, 8, ["loading", "companyData", "onCompany"]),
                                (_ctx.companyError)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_ctx.companyError), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.isAdmin)
                      ? (_openBlock(), _createBlock(_component_TabPanel, { key: 1 }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_30, [
                              _createElementVNode("div", _hoisted_31, [
                                _createVNode(_component_AppConnection)
                              ])
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_TabPanel, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, [
                              _hoisted_35,
                              _hoisted_36,
                              (_ctx.isAdmin)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                    _createVNode(_component_CompanyUserInviteModal)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode(_component_CompanyUserList)
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_TabPanel, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("div", null, [
                            _createVNode(_component_ReportForm)
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    (_ctx.isAdmin)
                      ? (_openBlock(), _createBlock(_component_TabPanel, { key: 2 }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("div", _hoisted_40, [
                                _createVNode(_component_UserPaymentEntry)
                              ])
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.isAdmin)
                      ? (_openBlock(), _createBlock(_component_TabPanel, { key: 3 }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("div", _hoisted_42, [
                                _createVNode(_component_SubscriptionSelection)
                              ])
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["defaultIndex"]))
      : _createCommentVNode("", true)
  ]))
}